import React from 'react';
import './Widgets.css';

function Widgets() {
	return (
		<div>
			<iframe
				src='https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FCleverProgrammerr%2Fposts%2F1055003961569004&show_text=true&width=340&height=1500&appId'
				width='340'
				height='100%'
				style={{ border: 'none', overflow: 'hidden' }}
				scrolling='no'
				frameBorder='0'
				allowtransparency='true'
				allow='encrypted-media'
			></iframe>
		</div>
	);
}

export default Widgets;
